import { render, staticRenderFns } from "./OrdersInboundTableMobile.vue?vue&type=template&id=0d6a7642&scoped=true"
import script from "./OrdersInboundTableMobile.vue?vue&type=script&lang=js"
export * from "./OrdersInboundTableMobile.vue?vue&type=script&lang=js"
import style0 from "./OrdersInboundTableMobile.vue?vue&type=style&index=0&id=0d6a7642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a7642",
  null
  
)

export default component.exports